import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? match[1] : null;
        window.history.replaceState(null, "", window.location.pathname);
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }
        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId });
                setUser(data);
                navigate("/portal", { replace: true, state: { user: data } });
            } catch (err) {
                setError("Google sign-in failed. Please try again.");
                setTimeout(() => navigate("/login", { replace: true }), 2500);
            }
        })();
    }, [navigate, setUser]);

    return (
        <div data-testid="auth-callback" className="min-h-screen bg-ink text-white flex flex-col items-center justify-center gap-4">
            <div className="w-10 h-10 border-2 border-rose/30 border-t-rose rounded-full animate-spin" />
            <p className="text-white/60 text-sm">{error || "Signing you in with Google…"}</p>
        </div>
    );
}
